import React from 'react';
import PropTypes from 'prop-types';

const SendKycForm = ({ theme, fill, ...props }) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.6667 0.859981C13.5542 0.78816 13.4235 0.75 13.29 0.75C13.1565 0.75 13.0258 0.78816 12.9133 0.859981L0.379998 8.09331C0.261346 8.16332 0.165745 8.26648 0.104953 8.39011C0.0441608 8.51373 0.02083 8.65243 0.0378304 8.78914C0.0548309 8.92586 0.111421 9.05462 0.20064 9.15959C0.289858 9.26456 0.407814 9.34117 0.539998 9.37998L4.54 10.6333L4.66666 10.6666L5.20666 14.46C5.21901 14.6205 5.27616 14.7743 5.37163 14.904C5.46709 15.0336 5.59703 15.1339 5.74666 15.1933C5.84749 15.2377 5.95651 15.2604 6.06666 15.26C6.19151 15.265 6.31592 15.2425 6.43112 15.1941C6.54632 15.1457 6.64948 15.0726 6.73333 14.98L9.4 12.08L11.4 12.6533C11.4973 12.6808 11.5993 12.6873 11.6993 12.6723C11.7993 12.6574 11.895 12.6214 11.98 12.5666C12.0646 12.515 12.1367 12.4451 12.1909 12.362C12.2451 12.279 12.2801 12.1849 12.2933 12.0866L13.9667 1.54665C13.9912 1.41531 13.9758 1.27962 13.9223 1.15718C13.8688 1.03473 13.7797 0.931193 13.6667 0.859981ZM2.51333 8.48665L10.12 4.07998L5.08 9.33331L2.51333 8.48665ZM6.44666 13.1866L6.16 11.1866L6.45333 11.28L7.86666 11.68L6.44666 13.1866ZM11.0333 11.0866L7.46 10.08L6.57333 9.79331L12.14 3.99998L11.0333 11.0866Z"
      fill="white"
    />
  </svg>
);

SendKycForm.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default SendKycForm;
